import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { isMobileSidebarLayout, isSidebarVisuallyOpen } from '@/utils/sidebarLayout';

/**
 * Layout auth/app deve seguir a rota ativa (meta.layout), não o Vuex setado no beforeEach.
 * Se isAuth vier do store, Header/Sidebar somem antes do router-view trocar (flash no logout).
 */
export function useLayout() {
  const store = useStore();
  const route = useRoute();
  const viewportWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1200);

  const updateViewportWidth = () => {
    viewportWidth.value = window.innerWidth;
  };

  onMounted(() => {
    updateViewportWidth();
    window.addEventListener('resize', updateViewportWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateViewportWidth);
  });

  const layoutState = computed(() => {
    const showSidebar = store.state.is_show_sidebar;
    const isMobileSidebar = isMobileSidebarLayout(viewportWidth.value);
    // meta.layout da rota confirmada — sincroniza com a troca do router-view
    const isAuth = route.meta?.layout === 'auth';

    return {
      isAuth,
      showSidebar,
      isMobileSidebar,
      isSidebarVisuallyOpen: isSidebarVisuallyOpen(showSidebar, viewportWidth.value),
      sidebarSkipTransition: store.state.sidebar_skip_transition,
      menuStyle: store.state.menu_style,
      showSearch: store.state.is_show_search,
      layoutStyle: store.state.layout_style
    };
  });

  const toggleSidebar = () => {
    const next = !layoutState.value.showSidebar;
    store.commit('toggleSideBar', next);
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
      localStorage.setItem('sidebar_state_mobile', String(next));
    }
  };

  const toggleSearch = () => {
    store.commit('toggleSearch', !layoutState.value.showSearch);
  };

  return {
    layoutState,
    toggleSidebar,
    toggleSearch
  };
}
